/* Boss Bidet product-page quick-add behavior.
   Floating buy bar + finish/quantity popup, wired to the product's real variants.
   Ported from the Revolution landing page pattern. Self-contained, runs only when
   the .bb-pdp block is present (in-scope bidet product pages). No em dashes. */

(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.bb-pdp');
    if (!root) return;

    var sheet  = root.querySelector('.bb-pdp-sheet');
    var sticky = root.querySelector('.bb-pdp-sticky');
    if (!sheet) return;

    /* ---- Popup open / close ---- */
    function openSheet() {
      sheet.hidden = false;
      document.body.classList.add('bb-pdp-open');
    }
    function closeSheet() {
      sheet.hidden = true;
      document.body.classList.remove('bb-pdp-open');
    }

    document.querySelectorAll('[data-open-sheet]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openSheet(); });
    });
    sheet.querySelectorAll('[data-sheet-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) closeSheet();
    });

    /* ---- Price displays ---- */
    var sheetNow  = sheet.querySelector('.bb-pdp-sheet-now');
    var stickyNow = sticky ? sticky.querySelector('.bb-pdp-sticky-now') : null;
    function setPrice(text) {
      if (!text) return;
      if (sheetNow)  sheetNow.textContent = text;
      if (stickyNow) stickyNow.textContent = text;
    }

    /* ---- Variant selection ---- */
    var rows = sheet.querySelectorAll('.bb-pdp-variant-row');
    function selectedId() {
      var active = sheet.querySelector('.bb-pdp-variant-row.active');
      if (active) return active.getAttribute('data-variant-id');
      return sheet.getAttribute('data-variant-id');
    }
    rows.forEach(function (row) {
      if (row.hasAttribute('disabled')) return;
      row.addEventListener('click', function () {
        rows.forEach(function (r) { r.classList.remove('active'); r.setAttribute('aria-checked', 'false'); });
        row.classList.add('active');
        row.setAttribute('aria-checked', 'true');
        setPrice(row.getAttribute('data-price'));
      });
    });

    /* ---- Quantity stepper ---- */
    var qtyInput = sheet.querySelector('.bb-pdp-qty-input');
    function qty() { var v = parseInt(qtyInput ? qtyInput.value : '1', 10); return (isNaN(v) || v < 1) ? 1 : v; }
    var dec = sheet.querySelector('[data-qty-dec]');
    var inc = sheet.querySelector('[data-qty-inc]');
    if (dec && qtyInput) dec.addEventListener('click', function () { var v = qty(); if (v > 1) qtyInput.value = v - 1; });
    if (inc && qtyInput) inc.addEventListener('click', function () { qtyInput.value = qty() + 1; });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); });

    /* ---- Add to cart, then follow after-add (checkout), never dead-end ---- */
    var addBtn = sheet.querySelector('[data-sheet-add]');
    var dest = sheet.getAttribute('data-after-add') === 'cart' ? '/cart' : '/checkout';
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = selectedId();
        if (!id) { window.location.href = dest; return; }
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: qty() })
        })
        .then(function (res) { if (!res.ok) { throw new Error('add failed'); } return res.json(); })
        .then(function () { window.location.href = dest; })
        .catch(function () { window.location.href = dest; });
      });
    }

    /* ---- Sticky bar visibility ----
       Show once the real product form scrolls out of view above the viewport. */
    if (sticky && 'IntersectionObserver' in window) {
      var watchSel = sticky.getAttribute('data-watch');
      var watch = watchSel ? document.querySelector(watchSel) : null;
      if (watch) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        }, { threshold: 0 }).observe(watch);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
